export default "__VITE_ASSET__DGGN9o$j__"